const WalletIcon = ({ className }: { className: string }) => (
  <svg
    aria-hidden='true'
    height='70'
    viewBox='0 0 70 70'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.5 24.7917L40.1914 4.375L55.4167 21.822L52.0862 24.7917H17.5ZM8.75 27.7086H61.25V33.9622V62.7083H54.1362H8.75V27.7086ZM49.5833 45.2083C49.5833 46.8192 50.8892 48.125 52.5 48.125C54.1108 48.125 55.4167 46.8192 55.4167 45.2083C55.4167 43.5975 54.1108 42.2917 52.5 42.2917C50.8892 42.2917 49.5833 43.5975 49.5833 45.2083Z'
      fill='currentColor'
    />
  </svg>
);

export default WalletIcon;
